// extracted by mini-css-extract-plugin
export default {"wrap":"Select_wrap__d1c6u","select":"Select_select__H6yU7"};